'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// To re-enable French, add 'fr' back to this list. Translations (fr.json),
// the flag asset (theme/img/fr.svg), and dropdown wiring are intentionally kept in place.
var allowedLanguages = exports.allowedLanguages = ['en', 'de'];


//////////////////
// WEBPACK FOOTER
// ./app/utils/languages.js
// module id = 639
// module chunks = 0